import classNames from 'classnames';
import stylesColors from 'common/styles/styles.colors';
import * as React from 'react';

import styles from './style.module.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  showBorder?: boolean;
}

const TableContainer = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, style, showBorder, ...rest } = props;
  return (
    <div
      ref={ref}
      {...rest}
      className={classNames(styles.tableContainer, className)}
      style={{
        ...(showBorder
          ? {
              borderTop: `2px solid ${stylesColors.skyLighter}`,
              borderRight: `1px solid ${stylesColors.skyLighter}`,
              borderLeft: `2px solid ${stylesColors.skyLighter}`,
              borderBottom: `1px solid ${stylesColors.skyLighter}`,
            }
          : {}),
        ...style,
      }}
    />
  );
});

TableContainer.displayName = 'TableContainer';

export default TableContainer;
